export default __webpack_public_path__ + "static/media/logo-pequeno.8027af0e.svg";